import fetcher from '@api/fetchers';
import { CBT_RESERVE_FLOW } from '@cont/SeeAll/constants';
import {
  getCbtAllLocationsAPIKey,
  getCbtCentreChangeAPIKey,
  getCbtCentrePreferenceAPIKey,
  getCbtCentresAPIKey,
  getCbtLocationsAPIKey,
  getCbtReserveAPIKey
} from '@cont/SeeAll/utils';

export const fetchCbtLocations = (programmeUid) =>
  fetcher(getCbtLocationsAPIKey(programmeUid), { useCamelCase: false });

export const fetchCbtCentres = (programmeUid, city) =>
  fetcher(getCbtCentresAPIKey(programmeUid, city));

export const fetchCbtAllLocations = () =>
  fetcher(getCbtAllLocationsAPIKey(), { useCamelCase: false });

export const changeCbtCentre = (programmeUid, centreUid) =>
  fetcher(getCbtCentreChangeAPIKey(), {
    requestType: 'POST',
    body: {
      programme_uid: programmeUid,
      centre_uid: centreUid
    }
  });

export const recordCbtCentrePreference = ({ testSeriesUid, state, city }) =>
  fetcher(getCbtCentrePreferenceAPIKey(), {
    requestType: 'POST',
    body: {
      test_series_uid: testSeriesUid,
      state,
      city
    }
  });

export const reserveCbtSeat = (programmeUid, selection) =>
  fetcher(getCbtReserveAPIKey(), {
    requestType: 'POST',
    body: {
      centre_uid: selection.centreUid,
      user_id: selection.userId,
      name: selection.fullName,
      email: selection.email,
      programme_uid: programmeUid,
      flow: CBT_RESERVE_FLOW.STORE
    }
  });

export const reserveCbtSeatForCombo = (programmeUid, selection) =>
  fetcher(getCbtReserveAPIKey(), {
    requestType: 'POST',
    body: {
      centre_uid: selection.centreUid,
      user_id: selection.userId,
      name: selection.fullName,
      email: selection.email,
      programme_uid: programmeUid,
      flow: CBT_RESERVE_FLOW.COMBO
    }
  });

export const reserveCbtSeatForBundle = (cbtGoalUid, selection) =>
  fetcher(getCbtReserveAPIKey(), {
    requestType: 'POST',
    body: {
      centre_uid: selection.centreUid,
      user_id: selection.userId,
      name: selection.fullName,
      email: selection.email,
      cbt_goal_uid: cbtGoalUid,
      flow: CBT_RESERVE_FLOW.BUNDLE
    }
  });
